// extracted by mini-css-extract-plugin
export default {"LoaderWrap":"Loader_LoaderWrap__CyX4a"};